import React from 'react';
import Iframe from 'react-iframe';

const SecondaryDistrictPage = () => (
  <Iframe
    url='https://visualization.audit.samiksha.samagra.io/public/dashboard/31b07d54-9ab1-4999-8916-5072fa590557?district=Ambala'
    width='100%'
    height='100%'
    display='initial'
    position='relative'
  />
);

export default SecondaryDistrictPage;
